import React from "react";
import Select from "react-select";
import InputText from "../../../common/Input/InputText";
import styles from "../editLabReport.module.scss";

const dropdownConfig = {
  Color: ["Yellowish","Straw","Pale Yellow","Reddish","Orange","Green","Milky"],
  Appearance: ["Hazy", "Slightly Hazy", "Clear"],
  Sediment: ["Present","Absent"],
  Reaction: ["Acidic", "Alkaline"],
  Sugar: ["Nil","Present(+)","Present(++)","Present(+++)","Present(++++)","Trace"],
  Albumin: ["Nil","Present(+)","Present(++)","Present(+++)","Present(++++)","Trace"],
  "Bile Salt": ["Present", "Absent", "Not Done"],
  "Bile Pigment": ["Present", "Absent", "Not Done"],
  "Ketone Bodies": ["Present", "Absent", "Not Done"],
  Cast: ["Nil","Hyaline","Granular","Waxy","Fatty","RBC","WBC","Bacterial","Epithelial"],
  Crystal: ["Nil","Uric Acid","Phosphate","Calcium Oxalates","Triple Phosphates","Cystine","Leucine","Ethyline Glycol","Amorphous Sediments","Tyrosine","Drug Associated","Calcium Phosphate"],
  Chyle: ["Present(++)", "Absent(--)","Present(+)","Absent(-)"],
   Bacteria: [
    "Nil",
    "Present(+)",
    "Present(++)",
    "Present(+++)",
    "Present(++++)"
  ],
};

const sectionConfig = {
  MACROSCOPIC: ["Color", "Appearance", "Sediment", "Reaction", "Specific Gravity"],
  CHEMICAL: ["Sugar", "Albumin", "Bile Salt", "Bile Pigment", "Ketone Bodies"],
  MICROSCOPIC: ["Pus cell","Epithelial cell","RBC","Cast","Crystal","Spermatozoa","Bacteria","Chyle","Others"],
};

const UrineRMProfile = ({ profile, testMap, handleTestProfileChange }) => {
  const renderField = (item, index) => {
    const testData = testMap.get(item._id) || {};
    const testName = item?.testName;

    const options = dropdownConfig[testName];
    const isDropdown = !!options;
    const isSpecificGravity = testName === "Specific Gravity";

    return (
      <div className={styles.testAndProfileWrapper} key={index}>
        
        <div className={styles["inputWrapper"]}>
          <div className="form-group">
            <InputText value={testName} label="Test Name" readOnly />
          </div>
        </div>

        <div className={styles["inputWrapper"]}>
          <div className="form-group">

            {isDropdown && (
              <>
                <label className="col-form-label">Value:</label>
                <Select
                  placeholder="Select Value"
                  value={
                    testData.value
                      ? { label: testData.value, value: testData.value }
                      : null
                  }
                  onChange={(e) =>
                    handleTestProfileChange(e, "value", profile._id, item._id)
                  }
                  options={options.map((opt) => ({
                    label: opt,
                    value: opt,
                  }))}
                />
              </>
            )}

            {(!isDropdown || isSpecificGravity) && (
              <InputText
                value={testData.value || ""}
                onChange={(e) =>
                  handleTestProfileChange(e, "value", profile._id, item._id)
                }
                label="Value"
              />
            )}

          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {Object.keys(sectionConfig).map((section) => {
        const sectionTests = profile?.tests?.filter((test) =>
          sectionConfig[section].includes(test.testName)
        );

        if (!sectionTests?.length) return null;

        return (
          <div key={section}>
            <h4 style={{ marginTop: "20px", fontWeight: "600" }}>
              {section}
            </h4>
            {sectionTests.map((item, index) =>
              renderField(item, index)
            )}

          </div>
        );
      })}
    </>
  );
};

export default UrineRMProfile;